import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BranchProvider } from './contexts/BranchContext';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import DefaultRoute from './components/DefaultRoute';
import InventoryManagement from './components/InventoryManagement';
import SalesManagement from './components/SalesManagement';
import CustomerManagement from './components/CustomerManagement';
import DealerManagement from './components/DealerManagement';
import ExpenseManagement from './components/ExpenseManagement';
import ReportsAnalytics from './components/ReportsAnalytics';
import Settings from './components/Settings';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <BranchProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<DefaultRoute />} />
                  <Route path="/inventory" element={<InventoryManagement />} />
                  <Route path="/sales" element={<SalesManagement />} />
                  <Route path="/customers" element={<CustomerManagement />} />
                  <Route path="/dealers" element={<DealerManagement />} />
                  <Route path="/expenses" element={<ExpenseManagement />} />
                  <Route path="/reports" element={<ReportsAnalytics />} />
                  <Route path="/settings" element={<Settings />} />
                  {/* Add more routes as needed */}
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
        </BranchProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;